import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CriacaoChamadoComponent } from './criacao-chamado/criacao-chamado.component';
import { ListagemChamadosComponent } from './listagem-chamados/listagem-chamados.component';
import { ChamadosRoutingModule } from './chamados-routing.module';
import { InteracaoChamadoComponent } from './interacao-chamado/interacao-chamado.component';
import { FormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';


@NgModule({
  declarations: [
    CriacaoChamadoComponent,
    ListagemChamadosComponent,
    InteracaoChamadoComponent,
  ],
  imports: [
    CommonModule,
    ChamadosRoutingModule,
    FormsModule,
    SharedModule
  ]
})
export class ChamadosModule { }
